import { File } from "../../../services";

export const prepareOrderDocuments = async ({ files, insurance, fileInvoice }) => {
  const documents = files.map((file) => ({ file, type: 5 }));
  if (insurance && fileInvoice instanceof Blob) documents.push({ file: fileInvoice, type: 0 });
  return documents;
};

export const saveOrderDocuments = async (ids, documents, removedFileIds) => {
  if (documents.length && !ids.length) throw new Error("Missing order ID for document upload");
  const results = await Promise.allSettled(ids.flatMap((id) => documents.map(({ file, type }) => {
    const data = new FormData();
    data.append("file", file);
    data.append("orderId", id);
    data.append("type", type);
    data.append("FileName", file.name);
    data.append("name", file.name);
    data.append("Name", file.name);
    return File.addOrderDoc(data);
  })));
  const failed = results.find((result) => result.status === "rejected");
  if (failed) throw failed.reason;
  // Keep existing documents until their replacements have been uploaded successfully.
  await Promise.all(removedFileIds.map((id) => File.deleteDocumentOrders(id)));
};
